module.exports = __webpack_public_path__ + "img/yszc-phone.89b7f330.png";